/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Tables_P2Inputs */

const en_wc_tut_tables_p2 = /** @type {(inputs: Wc_Tut_Tables_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert → Pictures adds images you can crop, recolour and wrap text around (square, top and bottom, behind or in front of text).`)
};

/**
* | output |
* | --- |
* | "Insert → Pictures adds images you can crop, recolour and wrap text around (square, top and bottom, behind or in front of text)." |
*
* @param {Wc_Tut_Tables_P2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_tables_p2 = /** @type {((inputs?: Wc_Tut_Tables_P2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Tables_P2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_tables_p2(inputs)
});
export { wc_tut_tables_p2 as "wc.tut.tables.p2" }